module.exports = __webpack_public_path__ + "img/close.00aabfce.svg";